import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import base64 from 'base64-arraybuffer';
import uuidv4 from 'uuid/v4';
import localData from './localData';
import crypto from './Crypto';
import { getWsUrl } from './utils';
import statusCodes from './statusCodes';
import config from './config';
import errors from './errors';
import { appendBuffers, arrayBufferToString, stringToArrayBuffer } from './Crypto/utils';
import { compress, decompress } from './worker';
import { uploadBundleChunk } from './api/db';
var wsAlreadyConnected = 'Web Socket already connected';
var BACKOFF_RETRY_DELAY = 1000;
var MAX_RETRY_DELAY = 1000 * 30;
var BUNDLE_CHUNK_SIZE = 1024 * 512; // 512kb

var BUNDLE_CHUNKS_PER_BATCH = 10;
var WS_REQUEST_TIMEOUT = 30 * 1000;
var clientId = uuidv4(); // only 1 client ID per browser tab (assumes code does not reload)

var RequestFailed = /*#__PURE__*/function (_Error) {
  _inherits(RequestFailed, _Error);

  var _super = _createSuper(RequestFailed);

  function RequestFailed(action, e) {
    var _this;

    _classCallCheck(this, RequestFailed);

    for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      params[_key - 2] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.name = "RequestFailed: ".concat(action);
    _this.message = e.message;
    _this.status = e.status || e.message === 'timeout' && statusCodes['Gateway Timeout'];
    _this.response = e.status && e;
    return _this;
  }

  return RequestFailed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var WebSocketError = /*#__PURE__*/function (_Error2) {
  _inherits(WebSocketError, _Error2);

  var _super2 = _createSuper(WebSocketError);

  function WebSocketError(message, username, e) {
    var _this2;

    _classCallCheck(this, WebSocketError);

    for (var _len2 = arguments.length, params = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      params[_key2 - 3] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'WebSocket error';
    _this2.message = message;
    _this2.username = username;
    _this2.e = e;
    return _this2;
  }

  return WebSocketError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Connection = /*#__PURE__*/function () {
  function Connection() {
    _classCallCheck(this, Connection);

    this.init();
  }

  _createClass(Connection, [{
    key: "init",
    value: function init(resolveConnection, rejectConnection, session, seedString, rememberMe, changePassword, state, encryptionMode) {
      if (this.pingTimeout) clearTimeout(this.pingTimeout);

      for (var _i = 0, _Object$keys = Object.keys(this); _i < _Object$keys.length; _i++) {
        var property = _Object$keys[_i];
        delete this[property];
      }

      this.ws = null;
      this.connected = false;
      this.resolveConnection = resolveConnection;
      this.rejectConnection = rejectConnection;
      this.connectionResolved = false;
      this.session = {
        username: session && session.username,
        sessionId: session && session.sessionId,
        creationDate: session && session.creationDate,
        expirationDate: session && session.expirationDate,
        userId: session && session.userId,
        authToken: session && session.authToken
      };
      this.seedString = seedString;
      this.changePassword = changePassword;
      this.keys = {
        init: false,
        salts: {}
      };
      this.userData = {
        stripeData: {}
      };
      this.rememberMe = rememberMe;
      this.requests = {};
      this.state = state || {
        dbNameToHash: {},
        databases: {},
        // used when openDatabase is called with databaseName
        databasesByDbId: {},
        // used when openDatabase is called with databaseId
        shareTokenIdToDbId: {} // used when openDatabase is called with shareToken

      };
      this.encryptionMode = encryptionMode;
    }
  }, {
    key: "connect",
    value: function connect(session) {
      var _this3 = this;

      var seedString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rememberMe = arguments.length > 2 ? arguments[2] : undefined;
      var changePassword = arguments.length > 3 ? arguments[3] : undefined;
      var reconnectDelay = arguments.length > 4 ? arguments[4] : undefined;
      var state = arguments.length > 5 ? arguments[5] : undefined;
      if (this.connected) throw new WebSocketError(wsAlreadyConnected, this.session.username);
      return new Promise(function (resolve, reject) {
        var timeout = false;
        var timeoutToOpenWebSocket = setTimeout(function () {
          if (!_this3.connected && !_this3.reconnecting) {
            timeout = true;
            reject(new WebSocketError('timeout'));
          }
        }, 10000);
        var url = "".concat(getWsUrl(config.getEndpoint()), "/api?appId=").concat(config.getAppId(), "&sessionId=").concat(session.sessionId, "&clientId=").concat(clientId, "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
        var ws = new WebSocket(url);
        ws.onopen = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!timeout) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  clearTimeout(timeoutToOpenWebSocket);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        ws.onmessage = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
            var message, route, action, encryptionMode, keySalts, validationMessage, ecKeyData, encryptedValidationMessage, userData, dbId, dbNameHash, database, openingDatabase, dbKeyString, _iterator, _step, _step$value, userId, username, bundle, newTransactions, startApplyingNextBatchInQueue, _dbId, _dbNameHash, isOwner, bundleSeqNo, isFirstChunk, isLastChunk, chunk, _database, requestId, request, response, successfulResponse;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!timeout) {
                      _context2.next = 2;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 2:
                    _context2.prev = 2;
                    message = JSON.parse(e.data);
                    route = message.route;
                    _context2.t0 = route;
                    _context2.next = _context2.t0 === 'Ping' ? 8 : _context2.t0 === 'Connection' ? 12 : _context2.t0 === 'ApplyTransactions' ? 43 : _context2.t0 === 'DownloadBundleChunk' ? 99 : _context2.t0 === 'UpdatedUser' ? 107 : _context2.t0 === 'SignOut' ? 109 : _context2.t0 === 'UpdateUser' ? 109 : _context2.t0 === 'DeleteUser' ? 109 : _context2.t0 === 'CreateDatabase' ? 109 : _context2.t0 === 'OpenDatabase' ? 109 : _context2.t0 === 'OpenDatabaseByDatabaseId' ? 109 : _context2.t0 === 'GetDatabases' ? 109 : _context2.t0 === 'GetDatabaseUsers' ? 109 : _context2.t0 === 'Insert' ? 109 : _context2.t0 === 'Update' ? 109 : _context2.t0 === 'Delete' ? 109 : _context2.t0 === 'BatchTransaction' ? 109 : _context2.t0 === 'InitBundleUpload' ? 109 : _context2.t0 === 'CompleteBundleUpload' ? 109 : _context2.t0 === 'GenerateFileId' ? 109 : _context2.t0 === 'UploadFileChunk' ? 109 : _context2.t0 === 'CompleteFileUpload' ? 109 : _context2.t0 === 'GetChunk' ? 109 : _context2.t0 === 'ValidateKey' ? 109 : _context2.t0 === 'GetPasswordSalts' ? 109 : _context2.t0 === 'PurchaseSubscription' ? 109 : _context2.t0 === 'CancelSubscription' ? 109 : _context2.t0 === 'ResumeSubscription' ? 109 : _context2.t0 === 'UpdatePaymentMethod' ? 109 : _context2.t0 === 'ShareDatabase' ? 109 : _context2.t0 === 'ShareDatabaseToken' ? 109 : _context2.t0 === 'AuthenticateShareToken' ? 109 : _context2.t0 === 'SaveDatabase' ? 109 : _context2.t0 === 'ModifyDatabasePermissions' ? 109 : _context2.t0 === 'VerifyUser' ? 109 : 126;
                    break;

                  case 8:
                    _this3.heartbeat();

                    action = 'Pong';

                    _this3.ws.send(JSON.stringify({
                      action: action
                    }));

                    return _context2.abrupt("break", 128);

                  case 12:
                    encryptionMode = message.encryptionMode;

                    _this3.init(resolve, reject, session, seedString, rememberMe, changePassword, state, encryptionMode);

                    _this3.ws = ws;

                    _this3.heartbeat();

                    _this3.connected = true; // seedString not present on initial connection when still need to change password

                    if (!seedString) {
                      _context2.next = 40;
                      break;
                    }

                    keySalts = message.keySalts, validationMessage = message.validationMessage, ecKeyData = message.ecKeyData, encryptedValidationMessage = message.encryptedValidationMessage;
                    _this3.keys.salts = keySalts;
                    _this3.validationMessage = validationMessage;
                    _this3.ecKeyData = ecKeyData; // provided by userbase-server for users who have not yet generated their ECDSA key and
                    // still only have a DH key

                    if (encryptedValidationMessage) _this3.encryptedValidationMessage = new Uint8Array(encryptedValidationMessage.data);
                    _context2.prev = 23;
                    _context2.next = 26;
                    return _this3.setKeys(_this3.seedString);

                  case 26:
                    _context2.next = 28;
                    return _this3.validateKey();

                  case 28:
                    userData = _context2.sent;
                    _this3.userData = userData;
                    _context2.next = 39;
                    break;

                  case 32:
                    _context2.prev = 32;
                    _context2.t1 = _context2["catch"](23);

                    if (!(_context2.t1 && _context2.t1.name === 'OperationError' || _context2.t1 instanceof DOMException)) {
                      _context2.next = 38;
                      break;
                    }

                    throw new Error('Invalid seed');

                  case 38:
                    throw _context2.t1;

                  case 39:
                    _this3.keys.init = true;

                  case 40:
                    _this3.resolveConnection();

                    _this3.connectionResolved = true;
                    return _context2.abrupt("break", 128);

                  case 43:
                    dbId = message.dbId;
                    dbNameHash = message.dbNameHash; // if owner, must have opened the database via databaseName

                    database = message.isOwner ? _this3.state.databases[dbNameHash] : _this3.state.databasesByDbId[dbId];

                    if (database) {
                      _context2.next = 48;
                      break;
                    }

                    throw new Error('Missing database');

                  case 48:
                    if (!database.applyTransactionsQueue.isEmpty()) {
                      _context2.next = 52;
                      break;
                    }

                    // take a spot in the queue and proceed applying so the next caller knows queue is not empty
                    database.applyTransactionsQueue.enqueue(null);
                    _context2.next = 54;
                    break;

                  case 52:
                    _context2.next = 54;
                    return new Promise(function (resolve) {
                      var startApplyingThisBatchOfTransactions = resolve;
                      database.applyTransactionsQueue.enqueue(startApplyingThisBatchOfTransactions);
                    });

                  case 54:
                    openingDatabase = message.dbNameHash && (message.dbKey || message.plaintextDbKey) || message.shareTokenEncryptedDbKey;

                    if (!(openingDatabase && (!database.dbKeyString || !database.dbKey))) {
                      _context2.next = 73;
                      break;
                    }

                    _context2.t2 = message.plaintextDbKey;

                    if (_context2.t2) {
                      _context2.next = 68;
                      break;
                    }

                    if (!message.dbKey) {
                      _context2.next = 64;
                      break;
                    }

                    _context2.next = 61;
                    return crypto.aesGcm.decryptString(_this3.keys.encryptionKey, message.dbKey);

                  case 61:
                    _context2.t3 = _context2.sent;
                    _context2.next = 67;
                    break;

                  case 64:
                    _context2.next = 66;
                    return database.decryptShareTokenEncryptedDbKey(message.shareTokenEncryptedDbKey, message.shareTokenEncryptionKeySalt);

                  case 66:
                    _context2.t3 = _context2.sent;

                  case 67:
                    _context2.t2 = _context2.t3;

                  case 68:
                    dbKeyString = _context2.t2;
                    database.dbKeyString = dbKeyString;
                    _context2.next = 72;
                    return crypto.aesGcm.getKeyFromKeyString(dbKeyString);

                  case 72:
                    database.dbKey = _context2.sent;

                  case 73:
                    if (database.dbKey) {
                      _context2.next = 75;
                      break;
                    }

                    throw new Error('Missing db key');

                  case 75:
                    if (message.writers) {
                      database.attributionEnabled = true;
                      _iterator = _createForOfIteratorHelper(message.writers);

                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          _step$value = _step.value, userId = _step$value.userId, username = _step$value.username;
                          database.usernamesByUserId.set(userId, username);
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    } // server is sending bundle in chunks, wait until it sends the entire bundle and client applies it


                    if (!message.waitForFullBundle) {
                      _context2.next = 92;
                      break;
                    }

                    if (database.finishedWaitingForBundle) {
                      _context2.next = 80;
                      break;
                    }

                    _context2.next = 80;
                    return new Promise(function (resolve) {
                      return database.finishedWaitingForBundle = resolve;
                    });

                  case 80:
                    _context2.prev = 80;
                    _context2.next = 83;
                    return _this3.rebuildBundle(database, message.bundleSeqNo, message.encryptedBundleEncryptionKey);

                  case 83:
                    bundle = _context2.sent;
                    _context2.next = 86;
                    return database.applyBundle(bundle, message.bundleSeqNo);

                  case 86:
                    _context2.next = 92;
                    break;

                  case 88:
                    _context2.prev = 88;
                    _context2.t4 = _context2["catch"](80);
                    window.alert("Oops! Something went wrong. Please contact the site administrator with this issue (".concat(dbId, ").\n\n") + _context2.t4);
                    throw _context2.t4;

                  case 92:
                    newTransactions = message.transactionLog;
                    _context2.next = 95;
                    return database.applyTransactions(newTransactions, message.ownerId, dbId, dbNameHash);

                  case 95:
                    if (message.buildBundle) {
                      _this3.buildBundle(database);
                    } // start applying next batch in queue when this one is finished applying successfully


                    database.applyTransactionsQueue.dequeue();

                    if (!database.applyTransactionsQueue.isEmpty()) {
                      startApplyingNextBatchInQueue = database.applyTransactionsQueue.peek();
                      startApplyingNextBatchInQueue();
                    }

                    return _context2.abrupt("break", 128);

                  case 99:
                    _dbId = message.dbId, _dbNameHash = message.dbNameHash, isOwner = message.isOwner, bundleSeqNo = message.bundleSeqNo, isFirstChunk = message.isFirstChunk, isLastChunk = message.isLastChunk, chunk = message.chunk; // if owner, must have opened the database via databaseName

                    _database = isOwner ? _this3.state.databases[_dbNameHash] : _this3.state.databasesByDbId[_dbId];

                    if (_database) {
                      _context2.next = 103;
                      break;
                    }

                    throw new Error('Missing database');

                  case 103:
                    // assumes server will always send first chunk first, and last chunk last
                    if (isFirstChunk) _database.bundleChunks[bundleSeqNo] = [];

                    _database.bundleChunks[bundleSeqNo].push(chunk);

                    if (isLastChunk) {
                      if (_database.finishedWaitingForBundle) _database.finishedWaitingForBundle();else _database.finishedWaitingForBundle = true;
                    }

                    return _context2.abrupt("break", 128);

                  case 107:
                    _this3.handleUpdateUser(message.updatedUser);

                    return _context2.abrupt("break", 128);

                  case 109:
                    requestId = message.requestId;

                    if (requestId) {
                      _context2.next = 112;
                      break;
                    }

                    return _context2.abrupt("return", console.warn('Missing request id'));

                  case 112:
                    request = _this3.requests[requestId];

                    if (request) {
                      _context2.next = 117;
                      break;
                    }

                    return _context2.abrupt("return", console.warn("Request ".concat(requestId, " no longer exists!")));

                  case 117:
                    if (!(!request.promiseResolve || !request.promiseReject)) {
                      _context2.next = 119;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 119:
                    response = message.response;
                    successfulResponse = response && response.status === statusCodes['Success'];

                    if (successfulResponse) {
                      _context2.next = 125;
                      break;
                    }

                    return _context2.abrupt("return", request.promiseReject(response));

                  case 125:
                    return _context2.abrupt("return", request.promiseResolve(response));

                  case 126:
                    console.log('Received unknown message from backend:' + JSON.stringify(message));
                    return _context2.abrupt("break", 128);

                  case 128:
                    _context2.next = 133;
                    break;

                  case 130:
                    _context2.prev = 130;
                    _context2.t5 = _context2["catch"](2);

                    if (!_this3.connectionResolved) {
                      _this3.close();

                      reject(new WebSocketError(_context2.t5.message, session.username, _context2.t5));
                    } else {
                      console.warn('Error handling message: ', _context2.t5);
                    }

                  case 133:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 130], [23, 32], [80, 88]]);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();

        ws.onclose = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
            var serviceRestart, clientDisconnected, attemptToReconnect, delay;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!timeout) {
                      _context3.next = 2;
                      break;
                    }

                    return _context3.abrupt("return");

                  case 2:
                    serviceRestart = e.code === statusCodes['Service Restart'];
                    clientDisconnected = e.code === statusCodes['No Pong Received'];
                    attemptToReconnect = serviceRestart || clientDisconnected || !e.wasClean; // closed without explicit call to ws.close()

                    if (!attemptToReconnect) {
                      _context3.next = 12;
                      break;
                    }

                    delay = serviceRestart && !reconnectDelay ? 0 : reconnectDelay ? reconnectDelay + BACKOFF_RETRY_DELAY : 1000;
                    _this3.reconnecting = true;
                    _context3.next = 10;
                    return _this3.reconnect(resolve, reject, session, _this3.seedString || seedString, rememberMe, changePassword, delay, !_this3.reconnected && state);

                  case 10:
                    _context3.next = 13;
                    break;

                  case 12:
                    if (e.code === statusCodes['Client Already Connected']) {
                      reject(new WebSocketError(wsAlreadyConnected, session.username, e));
                    } else {
                      _this3.init();
                    }

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }();

        ws.onerror = function () {}; // no-op so node WS implementation doesn't throw not found

      });
    }
  }, {
    key: "reconnect",
    value: function () {
      var _reconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolveConnection, rejectConnection, session, seedString, rememberMe, changePassword, reconnectDelay, currentState) {
        var _this4 = this;

        var retryDelay, dbsToReopen, dbsToReopenById;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                retryDelay = Math.min(reconnectDelay, MAX_RETRY_DELAY);
                console.log("Connection to server lost. Attempting to reconnect in ".concat(retryDelay / 1000, " second").concat(retryDelay !== 1000 ? 's' : '', "..."));
                dbsToReopen = [];
                dbsToReopenById = []; // as soon as one reconnect succeeds, resolves all the way up the stack and all reconnects succeed

                _context5.t0 = resolveConnection;
                _context5.next = 8;
                return new Promise(function (resolve, reject) {
                  return setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                    var state, dbNameHash, dbId, result;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            // get copy of currently opened databases' memory references to reopen WebSocket with same databases
                            state = currentState || {
                              dbNameToHash: _objectSpread({}, _this4.state.dbNameToHash),
                              databases: _objectSpread({}, _this4.state.databases),
                              databasesByDbId: _objectSpread({}, _this4.state.databasesByDbId),
                              shareTokenIdToDbId: _objectSpread({}, _this4.state.shareTokenIdToDbId)
                            }; // mark databases as uninitialized to prevent client from using them until they are reopened

                            // mark databases as uninitialized to prevent client from using them until they are reopened
                            for (dbNameHash in state.databases) {
                              state.databases[dbNameHash].init = false;
                              state.databases[dbNameHash].finishedWaitingForBundle = false;
                              dbsToReopen.push(dbNameHash);
                            }

                            for (dbId in state.databasesByDbId) {
                              state.databasesByDbId[dbId].init = false;
                              state.databasesByDbId[dbId].finishedWaitingForBundle = false;
                              dbsToReopenById.push(dbId);
                            }

                            _this4.init();

                            _this4.reconnecting = true;
                            _context4.next = 8;
                            return _this4.connect(session, seedString, rememberMe, changePassword, reconnectDelay, state);

                          case 8:
                            result = _context4.sent;
                            _this4.reconnected = true; // only reopen databases on the first call to reconnect()

                            if (currentState) {
                              _context4.next = 14;
                              break;
                            }

                            _context4.next = 13;
                            return _this4.reopenDatabases(dbsToReopen, dbsToReopenById, 1000);

                          case 13:
                            console.log('Reconnected!');

                          case 14:
                            resolve(result);
                            _context4.next = 20;
                            break;

                          case 17:
                            _context4.prev = 17;
                            _context4.t0 = _context4["catch"](0);
                            reject(_context4.t0);

                          case 20:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[0, 17]]);
                  })), retryDelay);
                });

              case 8:
                _context5.t1 = _context5.sent;
                (0, _context5.t0)(_context5.t1);
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t2 = _context5["catch"](0);
                rejectConnection(_context5.t2);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 12]]);
      }));

      function reconnect(_x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
        return _reconnect.apply(this, arguments);
      }

      return reconnect;
    }()
  }, {
    key: "reopenDatabases",
    value: function () {
      var _reopenDatabases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dbsToReopen, dbsToReopenById, retryDelay) {
        var _this5 = this;

        var openDatabasePromises, _iterator2, _step2, dbNameHash, database, action, params, _iterator3, _step3, databaseId, _database2, shareTokenHkdfKey, shareTokenAuthData, _action, _params;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                openDatabasePromises = []; // open databases by database name hash

                _iterator2 = _createForOfIteratorHelper(dbsToReopen);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    dbNameHash = _step2.value;
                    database = this.state.databases[dbNameHash];

                    if (!database.init) {
                      action = 'OpenDatabase';
                      params = {
                        dbNameHash: dbNameHash,
                        reopenAtSeqNo: database.lastSeqNo
                      };
                      openDatabasePromises.push(this.request(action, params));
                    }
                  } // open databases by database ID

                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                _iterator3 = _createForOfIteratorHelper(dbsToReopenById);
                _context7.prev = 5;

                _iterator3.s();

              case 7:
                if ((_step3 = _iterator3.n()).done) {
                  _context7.next = 25;
                  break;
                }

                databaseId = _step3.value;
                _database2 = this.state.databasesByDbId[databaseId];

                if (_database2.init) {
                  _context7.next = 23;
                  break;
                }

                shareTokenHkdfKey = _database2.shareTokenHkdfKey; // if opened with shareToken, need to reauthenticate it

                if (!shareTokenHkdfKey) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 15;
                return this.authenticateShareToken(_database2.shareTokenId, shareTokenHkdfKey);

              case 15:
                _context7.t0 = _context7.sent;
                _context7.next = 19;
                break;

              case 18:
                _context7.t0 = {};

              case 19:
                shareTokenAuthData = _context7.t0;
                _action = 'OpenDatabaseByDatabaseId';
                _params = _objectSpread({
                  databaseId: databaseId,
                  reopenAtSeqNo: _database2.lastSeqNo
                }, shareTokenAuthData);
                openDatabasePromises.push(this.request(_action, _params));

              case 23:
                _context7.next = 7;
                break;

              case 25:
                _context7.next = 30;
                break;

              case 27:
                _context7.prev = 27;
                _context7.t1 = _context7["catch"](5);

                _iterator3.e(_context7.t1);

              case 30:
                _context7.prev = 30;

                _iterator3.f();

                return _context7.finish(30);

              case 33:
                _context7.next = 35;
                return Promise.all(openDatabasePromises);

              case 35:
                _context7.next = 41;
                break;

              case 37:
                _context7.prev = 37;
                _context7.t2 = _context7["catch"](0);
                _context7.next = 41;
                return new Promise(function (resolve) {
                  return setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return _this5.reopenDatabases(dbsToReopen, dbsToReopenById, retryDelay + BACKOFF_RETRY_DELAY);

                          case 2:
                            resolve();

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  })), Math.min(retryDelay, MAX_RETRY_DELAY));
                });

              case 41:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 37], [5, 27, 30, 33]]);
      }));

      function reopenDatabases(_x11, _x12, _x13) {
        return _reopenDatabases.apply(this, arguments);
      }

      return reopenDatabases;
    }()
  }, {
    key: "heartbeat",
    value: function heartbeat() {
      var _this6 = this;

      clearTimeout(this.pingTimeout);
      var LATENCY_BUFFER = 3000;
      this.pingTimeout = setTimeout(function () {
        if (_this6.ws) _this6.ws.close(statusCodes['No Pong Received']);
      }, 30000 + LATENCY_BUFFER);
    }
  }, {
    key: "close",
    value: function close(code) {
      this.ws ? this.ws.close(code) : this.init();
    }
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var username, connectionResolved, rejectConnection, sessionId, action, params;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                username = this.session.username;
                connectionResolved = this.connectionResolved;
                rejectConnection = this.rejectConnection;
                _context8.prev = 3;
                localData.signOutSession(this.rememberMe, username);
                sessionId = this.session.sessionId;

                if (!this.reconnecting) {
                  _context8.next = 8;
                  break;
                }

                throw new errors.Reconnecting();

              case 8:
                action = 'SignOut';
                params = {
                  sessionId: sessionId
                };
                _context8.next = 12;
                return this.request(action, params);

              case 12:
                this.close();

                if (!connectionResolved && rejectConnection) {
                  rejectConnection(new WebSocketError('Canceled', username));
                }

                _context8.next = 20;
                break;

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](3);

                if (!connectionResolved && rejectConnection) {
                  rejectConnection(new WebSocketError('Canceled', username));
                }

                throw _context8.t0;

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 16]]);
      }));

      function signOut() {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "setKeys",
    value: function () {
      var _setKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(seedString) {
        var seed, masterKey, salts, ecdsaKeyEncryptionKey, encryptedEcdsaPrivateKey, rawEcdsaPrivateKey, ecdhKeyEncryptionKey, encryptedEcdhPrivateKey, rawEcdhPrivateKey, ecdsaKeyData, ecdhKeyData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!this.keys.init) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                if (seedString) {
                  _context9.next = 4;
                  break;
                }

                throw new WebSocketError('Missing seed', this.session.username);

              case 4:
                if (this.keys.salts) {
                  _context9.next = 6;
                  break;
                }

                throw new WebSocketError('Missing salts', this.session.username);

              case 6:
                if (!this.seedString) this.seedString = seedString;
                seed = base64.decode(seedString);
                _context9.next = 10;
                return crypto.hkdf.importHkdfKey(seed);

              case 10:
                masterKey = _context9.sent;
                salts = this.keys.salts;
                _context9.next = 14;
                return crypto.aesGcm.importKeyFromMaster(masterKey, base64.decode(salts.encryptionKeySalt));

              case 14:
                this.keys.encryptionKey = _context9.sent;
                _context9.next = 17;
                return crypto.hmac.importKeyFromMaster(masterKey, base64.decode(salts.hmacKeySalt));

              case 17:
                this.keys.hmacKey = _context9.sent;

                if (!salts.ecdsaKeyEncryptionKeySalt) {
                  _context9.next = 41;
                  break;
                }

                _context9.next = 21;
                return crypto.ecdsa.importEcdsaKeyEncryptionKeyFromMaster(masterKey, base64.decode(salts.ecdsaKeyEncryptionKeySalt));

              case 21:
                ecdsaKeyEncryptionKey = _context9.sent;
                encryptedEcdsaPrivateKey = base64.decode(this.ecKeyData.encryptedEcdsaPrivateKey);
                _context9.next = 25;
                return crypto.aesGcm.decrypt(ecdsaKeyEncryptionKey, encryptedEcdsaPrivateKey);

              case 25:
                rawEcdsaPrivateKey = _context9.sent;
                _context9.next = 28;
                return crypto.ecdsa.getPrivateKeyFromRawPrivateKey(rawEcdsaPrivateKey);

              case 28:
                this.keys.ecdsaPrivateKey = _context9.sent;
                _context9.next = 31;
                return crypto.ecdh.importEcdhKeyEncryptionKeyFromMaster(masterKey, base64.decode(salts.ecdhKeyEncryptionKeySalt));

              case 31:
                ecdhKeyEncryptionKey = _context9.sent;
                encryptedEcdhPrivateKey = base64.decode(this.ecKeyData.encryptedEcdhPrivateKey);
                _context9.next = 35;
                return crypto.aesGcm.decrypt(ecdhKeyEncryptionKey, encryptedEcdhPrivateKey);

              case 35:
                rawEcdhPrivateKey = _context9.sent;
                _context9.next = 38;
                return crypto.ecdh.getPrivateKeyFromRawPrivateKey(rawEcdhPrivateKey);

              case 38:
                this.keys.ecdhPrivateKey = _context9.sent;
                _context9.next = 45;
                break;

              case 41:
                if (!salts.dhKeySalt) {
                  _context9.next = 45;
                  break;
                }

                _context9.next = 44;
                return crypto.diffieHellman.importKeyFromMaster(masterKey, base64.decode(salts.dhKeySalt));

              case 44:
                this.keys.dhPrivateKey = _context9.sent;

              case 45:
                if (!(salts.dhKeySalt || salts.ecdsaKeyWrapperSalt)) {
                  _context9.next = 57;
                  break;
                }

                _context9.next = 48;
                return crypto.ecdsa.generateEcdsaKeyData(masterKey);

              case 48:
                ecdsaKeyData = _context9.sent;
                _context9.next = 51;
                return crypto.ecdh.generateEcdhKeyData(masterKey, ecdsaKeyData.ecdsaPrivateKey);

              case 51:
                ecdhKeyData = _context9.sent;
                this.keys.ecdsaPrivateKey = ecdsaKeyData.ecdsaPrivateKey;
                this.keys.ecdhPrivateKey = ecdhKeyData.ecdhPrivateKey;
                delete ecdsaKeyData.ecdsaPrivateKey;
                delete ecdhKeyData.ecdhPrivateKey;
                this.newEcKeyData = {
                  ecdsaKeyData: ecdsaKeyData,
                  ecdhKeyData: ecdhKeyData
                };

              case 57:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setKeys(_x14) {
        return _setKeys.apply(this, arguments);
      }

      return setKeys;
    }()
  }, {
    key: "validateKey",
    value: function () {
      var _validateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var validationMessage, sharedKey, action, params, response, userData;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this.keys.ecdsaPrivateKey && !this.keys.dhPrivateKey)) {
                  _context10.next = 6;
                  break;
                }

                _context10.next = 3;
                return crypto.ecdsa.sign(this.keys.ecdsaPrivateKey, base64.decode(this.validationMessage));

              case 3:
                validationMessage = _context10.sent;
                _context10.next = 14;
                break;

              case 6:
                if (!this.keys.dhPrivateKey) {
                  _context10.next = 14;
                  break;
                }

                _context10.next = 9;
                return crypto.diffieHellman.getSharedKeyWithServer(this.keys.dhPrivateKey);

              case 9:
                sharedKey = _context10.sent;
                _context10.next = 12;
                return crypto.aesGcm.decrypt(sharedKey, this.encryptedValidationMessage);

              case 12:
                validationMessage = _context10.sent;
                delete this.keys.dhPrivateKey;

              case 14:
                action = 'ValidateKey';
                params = {
                  validationMessage: base64.encode(validationMessage),
                  ecKeyData: this.newEcKeyData
                };
                _context10.next = 18;
                return this.request(action, params);

              case 18:
                response = _context10.sent;
                userData = response.data;
                return _context10.abrupt("return", userData);

              case 21:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function validateKey() {
        return _validateKey.apply(this, arguments);
      }

      return validateKey;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(action, params) {
        var requestId, responseWatcher, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // generate a new requestId
                requestId = uuidv4();
                this.requests[requestId] = {}; // get a promise that is resolved when the WebSocket
                // receives a response for this requestId — the promise
                // would time out of x seconds

                responseWatcher = this.watch(requestId); // send the request on the WebSocket

                this.ws.send(JSON.stringify({
                  requestId: requestId,
                  action: action,
                  params: params
                })); // wait for the response to arrive

                _context11.prev = 4;
                _context11.next = 7;
                return responseWatcher;

              case 7:
                response = _context11.sent;
                return _context11.abrupt("return", response);

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](4);

                if (!(_context11.t0.status === statusCodes['Too Many Requests'])) {
                  _context11.next = 17;
                  break;
                }

                throw new errors.TooManyRequests(_context11.t0.data.retryDelay);

              case 17:
                throw new RequestFailed(action, _context11.t0);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[4, 11]]);
      }));

      function request(_x15, _x16) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "watch",
    value: function () {
      var _watch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(requestId) {
        var _this7 = this;

        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return new Promise(function (resolve, reject) {
                  _this7.requests[requestId].promiseResolve = resolve;
                  _this7.requests[requestId].promiseReject = reject;
                  setTimeout(function () {
                    reject(new Error('timeout'));
                  }, WS_REQUEST_TIMEOUT);
                });

              case 2:
                response = _context12.sent;
                delete this.requests[requestId];
                return _context12.abrupt("return", response);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function watch(_x17) {
        return _watch.apply(this, arguments);
      }

      return watch;
    }()
  }, {
    key: "rebuildBundle",
    value: function () {
      var _rebuildBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(database, bundleSeqNo, encryptedBundleEncryptionKey) {
        var bundleChunks, i, chunk, chunkArrayBuffer, bundleArrayBuffer, _JSON$parse, encrypted, plaintextMetadata, bundleEncryptionKeyRaw, bundleEncryptionKey, decrypted, decryptedString, _yield$Promise$all, _yield$Promise$all2, decompressedEncrypted, decompressedPlaintextMetdata, bundle;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                bundleChunks = [];

                for (i = 0; i < database.bundleChunks[bundleSeqNo].length; i++) {
                  chunk = database.bundleChunks[bundleSeqNo][i];
                  chunkArrayBuffer = stringToArrayBuffer(chunk);
                  bundleChunks.push(chunkArrayBuffer);
                }

                bundleArrayBuffer = appendBuffers(bundleChunks).buffer;
                _JSON$parse = JSON.parse(arrayBufferToString(bundleArrayBuffer)), encrypted = _JSON$parse.encrypted, plaintextMetadata = _JSON$parse.plaintextMetadata;
                _context13.next = 6;
                return crypto.aesGcm.decrypt(database.dbKey, base64.decode(encryptedBundleEncryptionKey));

              case 6:
                bundleEncryptionKeyRaw = _context13.sent;
                _context13.next = 9;
                return crypto.aesGcm.getKeyFromRawKey(bundleEncryptionKeyRaw);

              case 9:
                bundleEncryptionKey = _context13.sent;
                _context13.next = 12;
                return crypto.aesGcm.decrypt(bundleEncryptionKey, stringToArrayBuffer(encrypted));

              case 12:
                decrypted = _context13.sent;
                decryptedString = arrayBufferToString(decrypted);
                _context13.next = 16;
                return Promise.all([decompress(decryptedString), decompress(plaintextMetadata)]);

              case 16:
                _yield$Promise$all = _context13.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                decompressedEncrypted = _yield$Promise$all2[0];
                decompressedPlaintextMetdata = _yield$Promise$all2[1];
                bundle = _objectSpread(_objectSpread({}, JSON.parse(decompressedEncrypted)), JSON.parse(decompressedPlaintextMetdata));
                delete database.bundleChunks[bundleSeqNo];
                return _context13.abrupt("return", bundle);

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function rebuildBundle(_x18, _x19, _x20) {
        return _rebuildBundle.apply(this, arguments);
      }

      return rebuildBundle;
    }()
  }, {
    key: "uploadBundle",
    value: function () {
      var _uploadBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(userId, dbId, seqNo, bundleId, bundleArrayBuffer) {
        var position, chunkNumber, batch, chunk;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                position = 0;
                chunkNumber = 0;
                batch = []; // will use this to send chunks to server in batches of BUNDLE_CHUNKS_PER_BATCH

              case 3:
                if (!(position < bundleArrayBuffer.byteLength)) {
                  _context14.next = 20;
                  break;
                }

                chunk = bundleArrayBuffer.slice(position, position + BUNDLE_CHUNK_SIZE); // using XHR to send binary data because Safari has trouble with string encoding over WebSocket

                batch.push(uploadBundleChunk(userId, dbId, seqNo, bundleId, chunkNumber, chunk));

                if (!(batch.length === BUNDLE_CHUNKS_PER_BATCH)) {
                  _context14.next = 16;
                  break;
                }

                _context14.prev = 7;
                _context14.next = 10;
                return Promise.all(batch);

              case 10:
                _context14.next = 15;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](7);
                return _context14.abrupt("return", 0);

              case 15:
                batch = [];

              case 16:
                chunkNumber += 1;
                position += BUNDLE_CHUNK_SIZE;
                _context14.next = 3;
                break;

              case 20:
                _context14.prev = 20;
                _context14.next = 23;
                return Promise.all(batch);

              case 23:
                _context14.next = 28;
                break;

              case 25:
                _context14.prev = 25;
                _context14.t1 = _context14["catch"](20);
                return _context14.abrupt("return", 0);

              case 28:
                return _context14.abrupt("return", chunkNumber);

              case 29:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[7, 12], [20, 25]]);
      }));

      function uploadBundle(_x21, _x22, _x23, _x24, _x25) {
        return _uploadBundle.apply(this, arguments);
      }

      return uploadBundle;
    }()
  }, {
    key: "initBundleUpload",
    value: function () {
      var _initBundleUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(dbId, seqNo, dbKey) {
        var action, params, initResponse, bundleId, _yield$crypto$aesGcm$, _yield$crypto$aesGcm$2, bundleEncryptionKey, encryptedBundleEncryptionKey;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                action = 'InitBundleUpload';
                params = {
                  dbId: dbId,
                  seqNo: seqNo
                };
                _context15.prev = 2;
                _context15.next = 5;
                return this.request(action, params);

              case 5:
                initResponse = _context15.sent;
                _context15.next = 11;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](2);
                return _context15.abrupt("return", {});

              case 11:
                bundleId = initResponse.data.bundleId;
                _context15.next = 14;
                return crypto.aesGcm.generateAndEncryptKeyEncryptionKey(dbKey);

              case 14:
                _yield$crypto$aesGcm$ = _context15.sent;
                _yield$crypto$aesGcm$2 = _slicedToArray(_yield$crypto$aesGcm$, 2);
                bundleEncryptionKey = _yield$crypto$aesGcm$2[0];
                encryptedBundleEncryptionKey = _yield$crypto$aesGcm$2[1];
                return _context15.abrupt("return", {
                  bundleId: bundleId,
                  bundleEncryptionKey: bundleEncryptionKey,
                  encryptedBundleEncryptionKey: base64.encode(encryptedBundleEncryptionKey)
                });

              case 19:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[2, 8]]);
      }));

      function initBundleUpload(_x26, _x27, _x28) {
        return _initBundleUpload.apply(this, arguments);
      }

      return initBundleUpload;
    }()
  }, {
    key: "orderedItems",
    value: function orderedItems(items, itemsIndex) {
      var orderedItemsArray = [];

      for (var i = 0; i < itemsIndex.array.length; i++) {
        var itemId = itemsIndex.array[i].itemId;
        orderedItemsArray.push(items[itemId]);
      }

      return orderedItemsArray;
    }
  }, {
    key: "prepareBundle",
    value: function prepareBundle(database) {
      var items = database.items,
          itemsIndex = database.itemsIndex,
          itemsPlaintextMetadata = database.itemsPlaintextMetadata;
      var bundle = {
        // these values are all provided as input values to SDK, or generated by SDK - will compress, then encrypt
        encrypted: JSON.stringify({
          items: this.orderedItems(items, itemsIndex),
          itemsIndex: itemsIndex.array
        }),
        // these are values the server has access to and can modify - will compress, but no need to encrypt and risk CRIME
        plaintextMetadata: JSON.stringify({
          itemsPlaintextMetadata: this.orderedItems(itemsPlaintextMetadata, itemsIndex)
        })
      };
      return bundle;
    }
  }, {
    key: "buildBundle",
    value: function () {
      var _buildBundle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(database) {
        var dbId, lastSeqNo, dbKey, userId, bundle, writers, _yield$this$initBundl, bundleId, bundleEncryptionKey, encryptedBundleEncryptionKey, _yield$Promise$all3, _yield$Promise$all4, compressedBeforeEncryption, compressedPlaintextMetadataString, compressedArrayBufferBeforeEncryption, encryptedItems, bundleArrayBuffer, numChunks, action, params;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                dbId = database.dbId;
                lastSeqNo = database.lastSeqNo;
                dbKey = database.dbKey;
                userId = this.session.userId; // Client will only attempt to bundle at a particular seqNo a single time. This prevents server from spamming
                // client with buildBundle to maliciously get the client to re-use an IV in AES-GCM and reveal the dbKey

                if (!(database.bundledAtSeqNo && database.bundledAtSeqNo >= lastSeqNo)) {
                  _context16.next = 8;
                  break;
                }

                return _context16.abrupt("return");

              case 8:
                database.bundledAtSeqNo = lastSeqNo;

              case 9:
                bundle = this.prepareBundle(database);
                writers = database.attributionEnabled ? _toConsumableArray(database.usernamesByUserId.keys()).join(',') : undefined;
                _context16.next = 13;
                return this.initBundleUpload(dbId, lastSeqNo, dbKey);

              case 13:
                _yield$this$initBundl = _context16.sent;
                bundleId = _yield$this$initBundl.bundleId;
                bundleEncryptionKey = _yield$this$initBundl.bundleEncryptionKey;
                encryptedBundleEncryptionKey = _yield$this$initBundl.encryptedBundleEncryptionKey;

                if (bundleId) {
                  _context16.next = 19;
                  break;
                }

                return _context16.abrupt("return");

              case 19:
                _context16.next = 21;
                return Promise.all([compress(bundle.encrypted), compress(bundle.plaintextMetadata)]);

              case 21:
                _yield$Promise$all3 = _context16.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                compressedBeforeEncryption = _yield$Promise$all4[0];
                compressedPlaintextMetadataString = _yield$Promise$all4[1];
                compressedArrayBufferBeforeEncryption = stringToArrayBuffer(compressedBeforeEncryption);
                _context16.next = 28;
                return crypto.aesGcm.encrypt(bundleEncryptionKey, compressedArrayBufferBeforeEncryption);

              case 28:
                encryptedItems = _context16.sent;
                bundle.encrypted = arrayBufferToString(encryptedItems);
                bundle.plaintextMetadata = compressedPlaintextMetadataString;
                bundleArrayBuffer = stringToArrayBuffer(JSON.stringify(bundle));
                _context16.next = 34;
                return this.uploadBundle(userId, dbId, lastSeqNo, bundleId, bundleArrayBuffer);

              case 34:
                numChunks = _context16.sent;

                if (numChunks) {
                  _context16.next = 37;
                  break;
                }

                return _context16.abrupt("return");

              case 37:
                action = 'CompleteBundleUpload';
                params = {
                  dbId: dbId,
                  seqNo: lastSeqNo,
                  bundleId: bundleId,
                  writers: writers,
                  numChunks: numChunks,
                  encryptedBundleEncryptionKey: encryptedBundleEncryptionKey
                };
                _context16.prev = 39;
                _context16.next = 42;
                return this.request(action, params);

              case 42:
                _context16.next = 47;
                break;

              case 44:
                _context16.prev = 44;
                _context16.t0 = _context16["catch"](39);
                return _context16.abrupt("return");

              case 47:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[39, 44]]);
      }));

      function buildBundle(_x29) {
        return _buildBundle.apply(this, arguments);
      }

      return buildBundle;
    }()
  }, {
    key: "buildUserResult",
    value: function buildUserResult(_ref6) {
      var username = _ref6.username,
          userId = _ref6.userId,
          authToken = _ref6.authToken,
          email = _ref6.email,
          profile = _ref6.profile,
          protectedProfile = _ref6.protectedProfile,
          usedTempPassword = _ref6.usedTempPassword,
          changePassword = _ref6.changePassword,
          passwordChanged = _ref6.passwordChanged,
          userData = _ref6.userData;
      var result = {
        username: username,
        userId: userId,
        authToken: authToken
      };
      if (email) result.email = email;
      if (profile) result.profile = profile;
      if (protectedProfile) result.protectedProfile = protectedProfile;
      if (usedTempPassword) result.usedTempPassword = usedTempPassword;
      if (changePassword) result.changePassword = changePassword;
      if (passwordChanged) result.passwordChanged = passwordChanged;

      if (userData) {
        var creationDate = userData.creationDate,
            stripeData = userData.stripeData;
        if (creationDate) result.creationDate = creationDate;

        if (stripeData) {
          var paymentsMode = stripeData.paymentsMode,
              subscriptionStatus = stripeData.subscriptionStatus,
              cancelSubscriptionAt = stripeData.cancelSubscriptionAt,
              subscriptionPlanId = stripeData.subscriptionPlanId,
              trialExpirationDate = stripeData.trialExpirationDate;
          if (paymentsMode) result.paymentsMode = paymentsMode;
          if (subscriptionStatus) result.subscriptionStatus = subscriptionStatus;
          if (cancelSubscriptionAt) result.cancelSubscriptionAt = cancelSubscriptionAt;
          if (subscriptionPlanId) result.subscriptionPlanId = subscriptionPlanId;
          if (trialExpirationDate) result.trialExpirationDate = trialExpirationDate;
        }
      }

      return result;
    }
  }, {
    key: "handleUpdateUser",
    value: function handleUpdateUser(updatedUser) {
      // make sure WebSocket session matches provided user
      if (this.session && this.session.userId === updatedUser['userId']) {
        this.session.username = updatedUser['username'];
        this.userData = updatedUser.userData;
        var updateUserHandler = config.getUpdateUserHandler();

        if (updateUserHandler) {
          updateUserHandler({
            user: this.buildUserResult(_objectSpread({
              authToken: this.session.authToken
            }, updatedUser))
          });
        }
      }
    }
  }, {
    key: "rotateKeys",
    value: function () {
      var _rotateKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(newSeedString, newKeyData) {
        var keySalts, ecKeyData, ecdsaKeyData, ecdhKeyData;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                // re-arrange object to fit expected structure for setKeys() function
                keySalts = newKeyData.keySalts, ecKeyData = newKeyData.ecKeyData;
                ecdsaKeyData = ecKeyData.ecdsaKeyData, ecdhKeyData = ecKeyData.ecdhKeyData;
                keySalts.ecdsaKeyEncryptionKeySalt = ecdsaKeyData.ecdsaKeyEncryptionKeySalt;
                keySalts.ecdhKeyEncryptionKeySalt = ecdhKeyData.ecdhKeyEncryptionKeySalt;
                this.keys.salts = keySalts;
                this.ecKeyData = _objectSpread(_objectSpread({}, ecdsaKeyData), ecdhKeyData);
                _context17.next = 8;
                return this.setKeys(newSeedString);

              case 8:
                this.keys.init = true;

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function rotateKeys(_x30, _x31) {
        return _rotateKeys.apply(this, arguments);
      }

      return rotateKeys;
    }()
  }, {
    key: "authenticateShareToken",
    value: function () {
      var _authenticateShareToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(shareTokenId, shareTokenHkdfKey) {
        var action, params, response, _response$data, databaseId, shareTokenAuthKeyData, validationMessage, shareTokenEcdsaPrivateKey, shareTokenEcdsaKeyEncryptionKeySalt, shareTokenEcdsaKeyEncryptionKey, shareTokenEncryptedEcdsaPrivateKey, shareTokenEcdsaPrivateKeyRaw, signedValidationMessage;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                // retrieve shareToken auth key data in order to prove access to shareToken to server
                action = 'AuthenticateShareToken';
                params = {
                  shareTokenId: shareTokenId
                };
                _context18.prev = 2;
                _context18.next = 5;
                return this.request(action, params);

              case 5:
                response = _context18.sent;
                _context18.next = 13;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](2);

                if (!(_context18.t0.response && _context18.t0.response.data === 'ShareTokenNotFound')) {
                  _context18.next = 12;
                  break;
                }

                throw new errors.ShareTokenNotFound();

              case 12:
                throw _context18.t0;

              case 13:
                _response$data = response.data, databaseId = _response$data.databaseId, shareTokenAuthKeyData = _response$data.shareTokenAuthKeyData, validationMessage = _response$data.validationMessage; // decrypt ECDSA private key. if it fails, not using the correct shareToken

                _context18.prev = 14;
                shareTokenEcdsaKeyEncryptionKeySalt = base64.decode(shareTokenAuthKeyData.shareTokenEcdsaKeyEncryptionKeySalt);
                _context18.next = 18;
                return crypto.ecdsa.importEcdsaKeyEncryptionKeyFromMaster(shareTokenHkdfKey, shareTokenEcdsaKeyEncryptionKeySalt);

              case 18:
                shareTokenEcdsaKeyEncryptionKey = _context18.sent;
                shareTokenEncryptedEcdsaPrivateKey = base64.decode(shareTokenAuthKeyData.shareTokenEncryptedEcdsaPrivateKey);
                _context18.next = 22;
                return crypto.aesGcm.decrypt(shareTokenEcdsaKeyEncryptionKey, shareTokenEncryptedEcdsaPrivateKey);

              case 22:
                shareTokenEcdsaPrivateKeyRaw = _context18.sent;
                _context18.next = 25;
                return crypto.ecdsa.getPrivateKeyFromRawPrivateKey(shareTokenEcdsaPrivateKeyRaw);

              case 25:
                shareTokenEcdsaPrivateKey = _context18.sent;
                _context18.next = 31;
                break;

              case 28:
                _context18.prev = 28;
                _context18.t1 = _context18["catch"](14);
                throw new errors.ShareTokenInvalid();

              case 31:
                _context18.next = 33;
                return crypto.ecdsa.sign(shareTokenEcdsaPrivateKey, base64.decode(validationMessage));

              case 33:
                signedValidationMessage = _context18.sent;
                return _context18.abrupt("return", {
                  databaseId: databaseId,
                  validationMessage: validationMessage,
                  signedValidationMessage: base64.encode(signedValidationMessage)
                });

              case 35:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[2, 8], [14, 28]]);
      }));

      function authenticateShareToken(_x32, _x33) {
        return _authenticateShareToken.apply(this, arguments);
      }

      return authenticateShareToken;
    }()
  }]);

  return Connection;
}();

export default new Connection();